import { render } from "./BaseShadowCard.vue?vue&type=template&id=015eabb0&scoped=true&ts=true"
import script from "./BaseShadowCard.vue?vue&type=script&lang=ts"
export * from "./BaseShadowCard.vue?vue&type=script&lang=ts"

import "./BaseShadowCard.vue?vue&type=style&index=0&id=015eabb0&scoped=true&lang=css"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015eabb0"]])

export default __exports__